import React from 'react'
import { FormControlLabel, Radio, RadioGroup, FormControl, FormHelperText } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

const ItemFormRadioGroup = ({
    name,
    labelKey,
    rules,
    options = [],
    required = false,
    ...props
}) => {
    const { t } = useTranslation()
    const { control, formState: { errors } } = useFormContext()
    const { labelPlacement = "start", row = true, disabled = false, readOnly = false } = props

    const error = get(errors, name)

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field }) => (
                <FormControlLabel
                    label={t(labelKey)}
                    labelPlacement={labelPlacement}
                    control={
                        <FormControl fullWidth error={!!error} sx={{ flex: 1 }}>
                            <RadioGroup
                                {...field}
                                row={row}
                                onChange={(event) => {
                                    if (readOnly) return;
                                    field.onChange(event);
                                }}
                                sx={{ width: '-webkit-fill-available', flexWrap: 'nowrap' }}
                            >
                                {options.map((op) => (
                                    <FormControlLabel
                                        key={op.value}
                                        value={op.value}
                                        control={<Radio disabled={disabled} />}
                                        label={t(op.label)}
                                        sx={{ '& .MuiFormControlLabel-label': { minWidth: 'unset !important' } }}
                                    />
                                ))}
                            </RadioGroup>
                            {error && <FormHelperText>{t(error.message)}</FormHelperText>}
                        </FormControl>
                    }
                />
            )}
        />
    )
}

export default ItemFormRadioGroup
